'use client';

import { useState, useContext, createContext, useMemo } from 'react';
import { SportItem } from '@/hooks/query';

interface MenuEditSectionContextType {
	//儲存目前menu收合狀態
	isMenuOpen: boolean;
	setIsMenuOpen: (isMenuOpen: boolean) => void;
	//儲存是否為同一次編輯狀態
	isFirst: boolean;
	setIsFirst: (isFirst: boolean) => void;
	//儲存編輯狀態
	isEdit: boolean;
	setIsEdit: (isEdit: boolean) => void;
	//儲存Reset狀態
	isReset: boolean;
	setIsReset: (isReset: boolean) => void;
	//儲存目前的sport sort(編輯中)
	sportSortList: Array<string>;
	setSportSortList: (sportSortList: Array<string>) => void;
	//依照目前編輯中的sport sort排列出的Array(編輯中)
	sportEditist: Array<SportItem>;
	setSportEditList: (sportEditist: Array<SportItem>) => void;
	//儲存最一開始的sport sort
	oriList: Array<SportItem>;
	setOriList: (oriList: Array<SportItem>) => void;
};

const MenuEditSectionContext = createContext<MenuEditSectionContextType>({
	isMenuOpen: false,
	setIsMenuOpen: () => { },
	isFirst: true,
	setIsFirst: () => { },
	isEdit: false,
	setIsEdit: () => { },
	isReset: false,
	setIsReset: () => { },
	sportSortList: [],
	setSportSortList: () => { },
	sportEditist: [],
	setSportEditList: () => { },
	oriList: [],
	setOriList: () => { }
});

export function MenuEditSectionProvider({ children }: { children: React.ReactNode }) {
	const [isMenuOpen, setIsMenuOpen] = useState(false);
	const [isFirst, setIsFirst] = useState(true);
	const [isEdit, setIsEdit] = useState(false);
	const [isReset, setIsReset] = useState(false);
	const [sportSortList, setSportSortList] = useState<string[]>([]);
	const [sportEditist, setSportEditList] = useState<SportItem[]>([]);
	const [oriList, setOriList] = useState<SportItem[]>([]);
	const value = useMemo(() => ({
		isMenuOpen,
		setIsMenuOpen,
		isFirst,
		setIsFirst,
		isEdit,
		setIsEdit,
		isReset,
		setIsReset,
		sportSortList,
		setSportSortList,
		sportEditist,
		setSportEditList,
		oriList,
		setOriList
	}), [
		isMenuOpen,
		setIsMenuOpen,
		isFirst,
		setIsFirst,
		isEdit,
		setIsEdit,
		isReset,
		setIsReset,
		sportSortList,
		setSportSortList,
		sportEditist,
		setSportEditList,
		oriList,
		setOriList
	]);

	return (
		<MenuEditSectionContext.Provider value={value}>
			{children}
		</MenuEditSectionContext.Provider>
	);
}

export const useMenuEditSection = () => useContext(MenuEditSectionContext);